import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const MainTitleComponent = styled.div`
    font-family: 'AvenirNextWorld Demi';
    display: flex;
    flex: ${(props) => (props.flexRatio ? props.flexRatio : 0.5)};
    font-size: 24px;
    align-content: 'left';
    color: #140f4b;
    margin: 0;
    padding-left: 0px;
    ${media.smalDevice`
        flex: ${(props) => (props.flexRatio ? props.flexRatio : 0.5)};
    `}
    ${media.mobileDevice`
        color: #ffff;
        padding-left: ${(props) =>
            props.isBackIconVisible
                ? props.mbReportPaymentPaddingLeft
                    ? props.mbReportPaymentPaddingLeft
                    : '8px'
                : '15px'};
        flex: ${(props) => (props.flexRatio ? props.flexRatio : 0.7)};
        font: 22px Avenir Next World;
        font-family: 'AvenirNextWorld Demi';
        align-items: center;
        justify-content: ${(isPriceOverride) => !isPriceOverride ? 'center' : 'flex-start'};
    `}
    //IPhone 12 Mini Media Query
    @media only screen and (max-width: 380px) {
        font-size: ${(props) => props.iPhoneMiniFontSize};
    }
    @media only screen and (max-device-width: 360px) {
        font-size: 18px;
    }
`;

export const VerticalDetailViewTop = styled.div`
    display: ${(props) => (props.displayType ? props.displayType : 'flex')};
    align-items: ${(props) =>
        props.flexAlign ? props.flexAlign : 'flex-start'};
    justify-content: ${(props) =>
        props.flexAlign ? props.flexAlign : 'center'};
    flex-direction: ${(props) =>
        props.fDirection ? props.fDirection : 'column'};
    flex: ${(props) =>
        props.lgFlexRatio
            ? props.lgFlexRatio
            : props.flexRatio
            ? props.flexRatio
            : 0.6};
    margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '60px')};
    margin-right: ${(props) => (props.marginRight ? props.marginRight : '0')};
    ${media.mediumDevice`
        display: block;
        margin-left : 0px;
    `}

    //ipad Pro(10.5 inch) portrait
      @media only screen and (min-device-width: 834px) and (max-device-width: 834px) and (orientation: portrait) {
        display: block;
    }



    ${media.mobileDevice`
        padding-right:${(props) =>
            props.mbPaddingRight ? props.mbPaddingRight : '23px'};
        flex: ${(props) => (props.mbFlexRatio ? props.mbFlexRatio : 0.5)};
        padding-bottom: 10px;
        -webkit-align-items: flex-end;
        display: -webkit-flex;
        `}

    //IPhone 12 Mini Media Query
    @media only screen and (max-width: 380px) {
        flex: ${(props) => props.iPhoneMiniFlexRatio};
        padding-right: ${(props) => props.iPhoneMiniPaddingRight};
    }

    @media (max-device-width: 1024px) {
        flex-ratio: 0.6;
        margin-right: 0;
        margin-top: 7px;
    }
`;

export const TitleComponent = styled.h3`
    ${media.mediumDevice`
        margin-left:${(props) => props.mdMarginLeft};
    `}
    ${media.mobileDevice`
        text-align: 'left';
        font: ${({ font }) => (font ? font : '15px Avenir Next World')};
        font-family: 'AvenirNextWorld Regular';
        letter-spacing: 0px;
        color: #FFFF;
        opacity: 1;
    `}
    font-size: 15px;
    color: #140f4b;
    margin: 0;
`;

export const SmallViewFlex = styled.div`    
    width:50%;
    flex: ${(props) => (props.flexRatio ? props.flexRatio : '1 1 23%')};
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    display: ${(props) => (props.displayType ? props.displayType : 'flex')};
    justify-content: ${(props) => props.isPriceOverride ? 'flex-start' : 'space-between'};
    white-space: nowrap;
    ${media.mediumDevice`
        flex:${(props) => props.mdViewSurgeryFlexRatio};
        flex-direction: ${(props) => props.mdFlexDirection};
        gap: 10px;
        width: ${(props) => props.mdWidth}
    `};
     ${media.smalDevice`
        width:100%;
        flex: ${(props) => (props.smFlexRatio ? props.smFlexRatio : 1.0)} !important;
        flex-direction: ${(props) =>
            props.fDirection ? props.fDirection : 'row'};
            justify-content: ${(props) => props.smJustifyContent} ;
    `}
    ${media.mobileDevice`
        width:100%;
        position: fixed;
        top:${({ bannerMargin }) =>
            bannerMargin ? `calc(${bannerMargin} - 3.8rem)` : '3.5rem'};
        background-color:#140f4b;
        z-index:${(props) => (props.shipAddress ? '-1' : '2000')};
        height: 55px;
        justify-content: ${(props) => props.isPriceOverride ? 'flex-start' : props.mbJustifyContent};
        align-items: center;
        padding-right: ${(props) => props.mbPaddingRight};
        // display: ${(props) =>
            props.displayType ? props.displayType : 'flex'};
        // flex-direction: ${(props) =>
            props.fDirection ? props.fDirection : 'row'};
        // padding-bottom : 0px;
        // background-color:#140f4b;
    `}
`;

export const ParentContainer = styled.div`
  /*
${media.smalDevice`
    flex-direction: ${(props) =>
        props.fDirection ? props.fDirection : 'column'};
    display: ${(props) => (props.displayType ? props.displayType : 'flex')};
    padding-top: ${(props) =>
        props.paddingTop ? props.paddingTop : '20px'};
    padding-bottom: ${(props) =>
        props.paddingBottom ? props.paddingBottom : '15px'};
`}
*/
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    font-family: 'AvenirNextWorld Demi';
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '17px')};
    padding-bottom: ${(props) =>
        props.paddingBottom ? props.paddingBottom : '31px'};
    display: ${(props) => (props.displayType ? props.displayType : 'flex')};
    background: ${(props) =>
        props.background
            ? props.background
            : '#f5f5f5 0% 0% no-repeat padding-box'};
    ${media.mediumDevice`
        flex-direction: ${(props) => (props.mdFlexDirection ? props.mdFlexDirection : 'row')};
        flex-wrap: ${(props) => (props.smFlexWrap ? props.smFlexWrap : 'nowrap')};
        gap: ${(props) => (props.smGap ? props.smGap : '0px')};
    `}
    ${media.mobileDevice`
    margin-top: ${(props) =>
        props.bannerMargin ? props.bannerMargin : 'unset'};
    flex-direction: ${(props) =>
        props.fDirection ? props.fDirection : 'column'};
    display: ${(props) => (props.displayType ? props.displayType : 'flex')};
        padding: ${({ mobilePadding }) => (mobilePadding ? mobilePadding : 0)};
        border-top-left-radius : ${({ borderTopLeft }) =>
            borderTopLeft ? borderTopLeft : '20px'};
        border-top-right-radius : ${({ borderTopRight }) =>
            borderTopRight ? borderTopRight : '20px'};
        `}
`;

export const IpadDivTop = styled.div`
    ${media.smalDevice`
        display: ${(props) => (props.displayType ? props.displayType : 'flex')};
        flex: ${(props) => (props.flexRatio ? props.flexRatio : 1)};
        flex-direction: ${(props) =>
            props.fDirection ? props.fDirection : 'row'};
        padding-bottom: ${(props) => (props.padding ? props.padding : '13px')};
        justify-content: ${(props) =>
            props.flexAlign ? props.flexAlign : 'space-between'};
`}
`;
//  flex: ${(props) => (props.flexRatio ? props.flexRatio : 0.8)};
//  flex-direction: ${(props) =>
// props.fDirection ? props.fDirection : 'row'};
//  display: ${(props) => (props.displayType ? props.displayType : 'flex')};
//  align-items: ${(props) =>
///  props.flexAlign ? props.flexAlign : 'center'};
//  justify-content: ${(props) =>
// props.flexAlign ? props.flexAlign : 'space-between'};

export const IpadDivBottom = styled.div`
    ${media.smalDevice`
    flex: ${(props) => (props.flexRatio ? props.flexRatio : 1)};
    justify-content: ${(props) =>
        props.flexAlign ? props.flexAlign : 'space-between'};
    text-align: ${(props) => (props.textAlign ? props.textAlign : 'left')};
    display: ${(props) => (props.displayType ? props.displayType : 'flex')};
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    align-items: flex-end;
    justify-content: center;
    text-align: right;  
        `}/* //  flex: ${(props) => (props.flexRatio ? props.flexRatio : 0.8)};
    //  flex-direction: ${(props) =>
        props.fDirection ? props.fDirection : 'row'};
    //  display: ${(props) => (props.displayType ? props.displayType : 'flex')};
    //  align-items: ${(props) =>
        props.flexAlign ? props.flexAlign : 'center'};
    //  justify-content: ${(props) =>
        props.flexAlign ? props.flexAlign : 'space-between'}; */
`;

export const VerticalDetailViewBottomLeft = styled.div`
    ${media.mediumDevice`
        margin-left: ${(props) => props.marginLeft};
        margin-right: ${(props) => props.mdMarginRight};
    `}
    display: ${(props) => (props.displayType ? props.displayType : 'flex')};
    align-items: ${(props) => (props.flexAlign ? props.flexAlign : 'flex-end')};
    justify-content: ${(props) =>
        props.flexAlign ? props.flexAlign : 'center'};
    flex-direction: ${(props) =>
        props.fDirection ? props.fDirection : 'column'};
    margin-right: ${(props) =>
        props.marginRight ? props.marginRight : 'unset'};
    min-width: 0;
    max-width: 350px;

    //ipad Pro(10.5 inch) landscape
    @media only screen and (min-device-width: 1112px) and (max-device-width: 1112px) and (orientation: landscape) and (-webkit-max-device-pixel-ratio: 2) {
        margin-left: 40px;
    }


    @media (max-device-width: 1024px) {
        white-space: nowrap;
        margin-right: 20px;
    }

 
    ${media.mediumDevice`
        margin: ${(props) => (props.smMargin ? props.smMargin : '20px')};
        flex: ${(props) => (props.smFlex ? props.smFlex : '')};
        align-items: ${(props) => (props.smAlignItems ? props.smAlignItems : 'flex-end')};
    `}
    ${media.mobileDevice`
        width : 100%;
        padding-left:${(props) => props.paddingLeft && props.paddingLeft};
        margin-left: 0px;
        -webkit-align-items: flex-start;
        margin-bottom: ${(props) => props.mbMarginBottom && props.mbMarginBottom};
    `}
`;
export const VerticalDetailViewBottomRight = styled.div`
    display: ${(props) => (props.displayType ? props.displayType : 'flex')};
    align-items: ${(props) =>
        props.flexAlign ? props.flexAlign : 'flex-start'};
    justify-content: ${(props) =>
        props.flexAlign ? props.flexAlign : 'center'};
    flex-direction: ${(props) =>
        props.fDirection ? props.fDirection : 'column'};
    margin-right: ${(props) => (props.marginRight ? props.marginRight : '0px')};
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        margin-right: ${(props) =>
            props.LandscapeMarginRight && props.LandscapeMarginRight};
    }
    ${media.mediumDevice`
    margin-right: ${(props) =>
        props.LandscapeMarginRight && props.LandscapeMarginRight};    
    `}

    ${media.smalDevice`
        flex: ${(props) => (props.flexRatio ? props.flexRatio : 0.5)};
        display: ${(props) => (props.displayType ? props.displayType : 'flex')};
        margin-right: 0px;
    `}
    ${media.mobileDevice`
        width: 100%;
        padding-left:${(props) => props.paddingLeft && props.paddingLeft}
    `}
`;

export const SurgeryDiv = styled.h4`
    font-size: 12px;
    color: #4f4f4f;
    margin: 0;
    font-family: 'AvenirNextWorld Regular';
    ${media.mediumDevice`
        margin-left:${(props) => props.mdMarginLeft};
    `}
    ${media.mobileDevice`
        font: ${({ font }) => (font ? font : '10px Avenir Next World')};
        font-family: 'AvenirNextWorld Regular';
        color: white;
        margin-left:0px;
    `}
`;

export const StyledSurgerySpan = styled.span`
    display: inline-block;
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '4px')};
    font-size: 12px;
    color: #140f4b !important;
    ${media.mobileDevice`
        color: white !important;
        font-size: 10px;
        font-family: 'AvenirNextWorld Regular';
    `}
    @media only screen and (max-device-width: 360px) {
        font-size: 9px;
    }
`;

export const BackIconContainer = styled.div`
    padding: ${(props) =>
        props.isReplenScreen
            ? '22px 10px 0 0'
            : props.isReportPayment
            ? '6px 10px 0 0'
            : '6px 22px 0 0'};
    ${media.mobileDevice`
        padding: ${(props) =>
            props.isReplenScreen ? '26px 7px 0 5px' : '7px 0 0 5px'};
        //  display: flex;
        //  flex: 0.30;
        //  align-items: center;
    `}
`;

export const BackIcon = styled.img`
    transform: rotate(90deg);
    cursor: pointer;
    ${media.mobileDevice`
        transform: unset;
        height: 22px;
        width: 22px;
    `}
`;

//price orverride components

export const PriceOverridePanelHeader = styled.div`
    ${media.mobileDevice`
        width:100%;
        position: fixed;
        top: 3.6rem;
        background-color:#140f4b;
        z-index: 2000;
`}
`;

export const PriceOverrideContentContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 16px 0px;
    ${media.smalDevice`
        justify-content: space-between;
    `}
    ${media.mobileDevice`
    justify-content: space-between;
        margin:0;
        padding:11px 0 1rem 15px;
    `}
    
    .flexItems {
        width: 25%;
    }
`;
export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 50%;
    ${media.smalDevice`
        justify-content: space-between;
    `}
    ${media.mobileDevice`
        justify-content: flex-start;
    `}
    .flexItems {
        width: 25%;
    }
`;

export const Icon = styled.div`
    height: 2.7rem;
    width: 2.7rem;
    cursor: pointer;
    position: relative;
    background-repeat: no-repeat;
    background-image: url(${(props) => props.deskPath});
    margin-right: ${(props) => props.marginRightDesktop || '0px'};
    margin-left: ${(props) => props.marginLeft || '0px'};

    ${media.mobileDevice`
        background-image: url(${(props) => props.mobilePath});
        margin-right: ${(props) => props.marginRightMobile || '0px'};
        bottom: ${(props) => props.bottom || 'unset'};
    `}
`;

export const Title = styled.h2`
    font-family: 'AvenirNextWorld Demi';
    margin: 0;
    color: #140f4b;
    font-size: 24px;
    margin-left: 0px;
    width: 100%;
    ${media.mediumDevice`
        flex: ${(props) => props.mdFlex};
    `}
    ${media.mobileDevice` 
        color: #ffffff;
        //font size and space issue
        font-size: 22px;
        padding: ${({ padding }) => (padding ? padding : '0px')};
        font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 'bold')};
    `}
    ${media.smalDevice`
        width: 66%;   
    `}

    .web {
        display: flex;
        color: #140f4b;
        align-items: center;
        justify-content: space-between;
        ${media.mobileDevice`
            display: none
        `}
    }

    .mobile {
        display: none;

        ${media.mobileDevice`
            display: block;
        `}
    }
`;

export const Heading = styled.div`
    position: relative;
    height: 41px;
    opacity: 1;
    margin: 0px 0px 0px 35px;
    display: flex;
    flex-direction: ${(props) =>
        props.fDirection ? props.fDirection : 'column'};
    ${media.smalDevice`
    margin-left:0;
    `}
`;

export const Text = styled.text`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    opacity: 1;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    color: ${({ color }) => (color ? color : '#140f4b')};
    text-align: left;
    margin: 0;
    margin-left: ${({ marginLeft }) => marginLeft && marginLeft};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    ${media.smalDevice`
text-align:  ${({ textAlign }) => (textAlign ? 'left' : 'right')};
`}
    ${media.mobileDevice`     
color: color: ${({ color }) => (color ? color : '#ffffff')}; 
 font-family: ${({ fontFamily }) =>
     fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    margin-left: ${({ marginLeft }) => marginLeft && marginLeft};
 
font-size: 15px;
`}
`;
export const Border = styled.div`
    width: 95vw;
    height: 0px;
    border-top: 1px solid #707070;
    opacity: 0.2;
    margin: ${({ margin }) => (margin ? margin : '20px 0')};
    align-self: center;
    background-color: #707070;
    z-index: -1;

    ${media.mediumDevice`
        width: calc(100% + 60px);
    `}
    ${media.smalDevice`
        width: calc(100% + 40px);
    `}
    ${media.mobileDevice`
        display: none
    `}
`;

export const StyledSpan = styled.span`
    color: ${({ color }) => (color ? color : '#140F4B')};
    padding: ${({ padding }) => (padding ? padding : '')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Thin'};
    font-size: 12px;
    font-weight: ${({ fontWeight }) => fontWeight};
    ${media.mobileDevice`
        font-family: ${(props) => props.mbFontFamily};
        padding: ${(props) => props.mbPadding};
    `}
`;

export const LineSeparator = styled.hr`
    border: 0;
    border-top: ${(props) =>
        props.borderTop ? props.borderTop : '1px solid #f5f5f5'};
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    width: ${(props) => (props.width ? props.width : '100%')};
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    ${media.mobileDevice`
        display: none
    `}
`;

export const AccountNameStyledDiv = styled.div`
    font-size: 12px;
    color: #140f4b;
    margin: 0;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    ${media.mobileDevice`
        font-family:'AvenirNextWorld Demi';
        font-weight: normal;
        max-width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    `}
`;
export const PhysicianNameStyledDiv = styled.div`
    font-size: 12px;
    color: #140f4b;
    margin: 0;
    padding: 0 4px 0 0;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    ${media.mobileDevice`
        font-family:'AvenirNextWorld Demi';
        margin-bottom: 13px;
    `}
`;

export const StyledDiv = styled.div`
    color: ${({ color }) => (color ? color : '#140F4B')};
    padding: ${({ padding }) => (padding ? padding : '')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Thin'};
    font-size: 12px;
    font-weight: ${({ fontWeight }) => fontWeight};
    ${media.mobileDevice`
        font-family: ${(props) => props.mbFontFamily};
    `}
`;

export const IconsContainer = styled.div`
    display: flex;
    justify-content: space-around;
    ${media.mobileDevice`
         width: 21%;
    `}
`;

export const IconPlaceHolder = styled.div`
    margin: ${({ margin }) => margin};
    /* border: 1px solid #140f4b; */
    opacity: 1;
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    //to make quick order header align
    /* margin-right: 17px;
     */
    ${'' /* margin-right: 10px; */}
    ${media.mediumDevice`
        display: ${(props) => (props.mdDisplay ? props.mdDisplay : 'block')}; 
        flex: ${(props) => props.mdFlex};
        justify-content: ${(props) => props.mdjustifyContent}   
    `}
    ${media.mobileDevice`
        margin-right : ${({ marginRight }) =>
            marginRight ? marginRight : '0px'};
    `}
`;

export const CountContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    right: ${(props) => (props.right ? props.right : '-1px')};
    top: ${(props) => (props.top ? props.top : '-11px')};
    position: absolute;
    background-color: ${(props) => (props.colorNote ? '#F5F5F5' : '#12C8F7')};
    width: ${(props) => (props.width ? props.width : '27px')};
    height: ${(props) => (props.height ? props.height : '27px')};
    border-radius: 50%;
    border: ${(props) =>
        props.desktopBorder ? props.desktopBorder : '1px solid #140f4b'};
    ${media.mobileDevice`
        right: ${(props) => (props.mbRight ? props.mbRight : '-1px')};
        top: ${(props) => (props.mbTop ? props.mbTop : '-12px')};
        background-color: ${(props) => props.backgroundColor};
        border : ${(props) => props.border};
    `}
`;

export const LabelCount = styled.span`
    display: inline-block;
    color: #140f4b;
    font-size: 12px;
    position: absolute;
    text-align: center;
    letter-spacing: -0.1px;
    line-height: 21px;
    font-family: 'AvenirNextWorld Demi';
    vertical-align: middle;
    width: 100%;
    ${media.mobileDevice`
        
        color : ${(props) => (props.colorNote ? '#ffffff' : '#140F4B')};
    `}
`;

export const BackIconNotes = styled.div`
    margin-top: 9px;
    ${media.mobileDevice`
display: none
`}
`;

export const SurgeryNoteBack = styled.label`
    width: 32px;
    height: 22px;
    text-align: left;
    font-size: 13px;
    color: #1010eb;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    cursor: pointer;
    margin-right: 0px;
    margin-top: 15px;

    ${media.mediumDevice`
            margin-right: 0px;
        `}

    ${media.smalDevice`
            margin-right: 0px;
        `}
`;
